import OurWork from "@/components/sections/OurWork";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { SEO_MAP } from "@/lib/seoMap";

export default function WorkPage() {
  return (
    <main data-testid="work-page">
      <SEO {...SEO_MAP.work} />
      <PageHeader overline="Our Work" title={<>Selected work<br /><em className="italic">across sectors</em>.</>}
                  lead="From our own products to bespoke client platforms — evidence, not adjectives." />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-6 -mt-6">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-9">
            <p className="text-[15px] text-[color:var(--text-muted)] leading-relaxed">
              The projects below are the ones we're proud to point at — a mixture of our own SaaS products
              (SyncLyn for business automation, Quixia for marketing operations, Vaultxy for cybersecurity)
              and bespoke client platforms across e-commerce, corporate services and internal business
              systems. Each engagement here shipped to real users, ran through the same weekly delivery
              cadence, and remains supported under an ongoing plan. We deliberately keep the portfolio
              focused rather than exhaustive: quality of thinking scales better than volume of case
              studies. Filter by capability below — Website, E-Commerce, Software, Automation or Business
              Systems — to see comparable work fastest, or reach out via the enquiry form for detailed
              case studies, architecture diagrams and outcomes not shown publicly.
            </p>
          </div>
        </div>
      </section>

      <OurWork />
    </main>
  );
}
